// extracted by mini-css-extract-plugin
export default {"formErrorNotice":"_8244be41"};